var DatePickerMobile = {
	"title-date": "Выберите дату",
	"title-day": "Выберите день",
	"title-time": "Выберите время",
	next: "Дальше",
	done: "Готово",
	yesterday: "Вчера",
	today: "Сегодня",
	tomorrow: "Завтра",
	"day-label": "Выберите день",
	"year-label": "Выберите год",
	"month-label": "Выберите месяц",
	"hours-label": "Выберите час",
	"minutes-label": "Выберите минуты",
	"timezone-label": "Выберите таймзону",
	"aria-header-postfix": "Закрыть",
	"aria-prev-step": "Предыдущий шаг"
};
var BottomSheet = {
	minimize: "Свернуть",
	maximize: "Развернуть"
};
var InputPhoneMobile = {
	title: "Выберите страну или регион",
	"aria-header-postfix": "Закрыть",
	placeholder: "Поиск",
	"input-aria-label": "Начните вводить код или название страны",
	"listbox-aria-label": "Страны",
	"select-control-aria-label": "Выбрать код страны"
};
var Modal = {
	"close-button-aria-label": "Закрыть"
};
var Tooltip = {
	"close-button-aria-label": "Закрыть"
};
var Calendar = {
	today: "Сегодня"
};
var DatepickerMultiple = {
	selected: "Выберите дату",
	selected_one: "Выбрана {{ count }} дата",
	selected_few: "Выбрано {{ count }} даты",
	selected_many: "Выбрано {{ count }} дат",
	selected_other: "Выбрано {{ count }} дат"
};
var Pagination = {
	page: "Страница",
	of: "из"
};
var FileLoader = {
	"attach-aria-label": "Прикрепить",
	"delete-file-aria-label": "Удалить файл",
	"retry-upload-aria-label": "Повторить загрузку",
	"uploading-in-progress-aria-label": "Выполняется загрузка",
	"loading-error-aria-label": "Ошибка загрузки"
};
var ru = {
	DatePickerMobile: DatePickerMobile,
	BottomSheet: BottomSheet,
	InputPhoneMobile: InputPhoneMobile,
	Modal: Modal,
	Tooltip: Tooltip,
	Calendar: Calendar,
	DatepickerMultiple: DatepickerMultiple,
	Pagination: Pagination,
	FileLoader: FileLoader
};

export { BottomSheet, Calendar, DatePickerMobile, DatepickerMultiple, FileLoader, InputPhoneMobile, Modal, Pagination, Tooltip, ru as default };
